// SecurityIssues.jsx
import React from "react";
import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";

import "./styles.scss";

const SecurityIssues = ({ issues }) => {
  if (!issues || issues.length === 0) {
    return (
      <CustomBox className="thunter-security-issues">
        <h2 className="thunter-security-issues__title">Security Issues</h2>
        <p className="thunter-security-issues__empty">No security issues detected</p>
      </CustomBox>
    );
  }

  const getSeverityInfo = (severity) => {
    switch (severity.toLowerCase()) {
      case "high":
        return { color: "#d32f2f" };
      case "medium":
        return { color: "#f57c00" };
      case "low":
        return { color: "#388e3c" };
      default:
        return { color: "#757575" };
    }
  };

  return (
    <CustomBox className="thunter-security-issues">
      <h2 className="thunter-security-issues__title">Security Issues</h2>

      <div className="thunter-security-issues__table">
        <div className="thunter-security-issues__head">
          <div className="thunter-security-issues__cell thunter-security-issues__cell--issue">
            Issue
          </div>
          <div className="thunter-security-issues__cell thunter-security-issues__cell--severity">
            Severity
          </div>
          <div className="thunter-security-issues__cell thunter-security-issues__cell--description">
            Description
          </div>
        </div>
        <div className="thunter-security-issues__content">
          {issues.map((issue, index) => {
            const { color } = getSeverityInfo(issue.severity);
            return (
              <div key={index} className="thunter-security-issues__row">
                <div className="thunter-security-issues__cell thunter-security-issues__cell--issue">
                  {issue.issue}
                </div>
                <div className="thunter-security-issues__cell thunter-security-issues__cell--severity">
                  <div className="thunter-security-issues__issue-severity">
                    <span
                      className="thunter-security-issues__severity-label"
                      style={{ backgroundColor: color }}>
                      {issue.severity.toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="thunter-security-issues__cell thunter-security-issues__cell--description">
                  {issue.description || "No description available"}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </CustomBox>
  );
};

export default SecurityIssues;
